import banner from "./banner.jpeg"
import logo from "./logo.jpg"

const shop = {
    id: "shop020",
  
    vendorId: "CoTWE5rKgcTj9G93zmxjvRbAb6k2",
  
    slug: "coldest-water-lagos",
  
    name: "The Coldest Water",
  
    category: "grocery",
  
    rating: 4.5,
  
    deliveryTime: "20-30 mins",
  
    featured: true,
  
    logo: logo,
  
    banner: banner,

    size: "small",

    products: [],

    location: "Lagos",

    deliveryPricing: {
      baseFee: 500,
      perKm: 180
    },

    location2: {
      area: "Wuse 2",
      city: "Abuja",
    
      coordinates: {
        lat: 9.0765,
        lng: 7.3986
      }
    },
   
  };
  
  export default shop;